import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { initAttribution } from '@/utils/attribution'
import '@/assets/style.css'
import '@/styles/breakpoints.css'
import '@/styles/product-density.css'
import '@/styles/modal-scroll.css'

initAttribution()

createApp(App).use(createPinia()).use(router).mount('#app')
